import TermsScreen from "./index";

const routes = [
  {
    path: "/terms",
    component: TermsScreen,
  },
];

export default routes;
